
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { ApiDataService } from "src/app/shared/services/api.service";
import { takeUntil } from "rxjs/operators";
import { StorageService } from "src/app/shared/services/storage.service";
import { LessonsApiService } from "../../../lessons/services/lessons-api.service";
import { LaserPointerComponent } from "../laser-pointer/laser-pointer.component";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { enagagementTabs, errorMessages, passageConfig, VIDEO_EMBED_URLS } from "../../constants/passage-constants";
import { StudentSession } from "src/app/shared/models/student-session";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "passage",
    templateUrl: "./passage.component.html",
    styleUrls: ["./passage.component.css"],
    standalone: false
})
export class Passage implements OnInit, OnDestroy {
  @Output() changeTab = new EventEmitter<number>();
  @ViewChild(LaserPointerComponent) laser!: LaserPointerComponent;
  @ViewChild('cloudTextarea') textareaRef!: ElementRef<HTMLTextAreaElement>;
  subscription: Subscription;
  loading = true;
  isSavingLoader=false
  tutorTipModal = false;
  firstReadingWords: string[] = [];
  secondReadingWords: string[] = [];
  firstReadingWordsIndex: number[] = [];
  secondReadingWordsIndex: number[] = [];
  whipWords: string[] = [];
  phoneticsWords: string = ''
  images: any[] = [];
  indexBasedImages: any[] = [];
  passageIndex: number = 0;
  passageDetails: any = {};
  tutorTip = "";
  ufliStrategyModal = false;
  sanitizedWordUrl: SafeResourceUrl;
  ufliStrategyClickFlag = false; // Flag to track if the UFLI strategy modal has been clicked
  passageEngagement = []
  lessonDetails: any;
  sessionData: StudentSession;
  showLaser = false;
  secondHearing = false;
  firstHearing = false;
  changesAdded = false;
  pingPongGame = false;
  currentStep = 0;
  ufliStrategies: string = '';
  numberOfPassages: number = 0;
  passageToggled=false;
  lessonVideoModal = false;
  sanitizedLessonVideoUrl: SafeResourceUrl | null = null;
  videoLoading = false;


  // for toggling cursor icons
  icons: string[] = [
    './assets/mouse_cursors/ball-yellow.svg',
    './assets/mouse_cursors/ball-blue.svg',
  ];
  currentIconIndex: number = 0;
  cursorIcon: string | null = null;

  private ngUnsubscribe = new Subject <void>();
  constructor(
    private apiService: ApiDataService,
    private lessonsApiService: LessonsApiService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
  ) {
  }
  ngAfterViewInit(): void {
    const textarea = this.textareaRef.nativeElement;
    textarea.addEventListener('input', () => {
     
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 145) + 'px';
    });
  }

  ngOnInit() {
    this.sessionData = StorageService.getSessionData();
    this.getLessonDetails()
    this.sanitizedWordUrl = this.sanitizer.bypassSecurityTrustResourceUrl(passageConfig.ufliUrl);
    this.toggleFirstHearing()
    document.body.style.cursor = `url(${this.icons[0]}) 16 16, auto`;
    this.getTutorTip()
  }

convertToEmbedUrl(url: string): string {
  // YouTube (standard)
  if (url.includes(VIDEO_EMBED_URLS.YOUTUBE_WATCH)) {
    const videoId = new URL(url).searchParams.get('v');
    return `${VIDEO_EMBED_URLS.YOUTUBE_EMBED}${videoId}`;
  }

  // YouTube (short)
  if (url.includes(VIDEO_EMBED_URLS.YOUTUBE_SHORT)) {
    const videoId = url.split('/').pop();
    return `${VIDEO_EMBED_URLS.YOUTUBE_EMBED}${videoId}`;
  }

  // Vimeo
  if (url.includes(VIDEO_EMBED_URLS.VIMEO_DOMAIN)) {
    const videoId = url.split('/').pop();
    return `${VIDEO_EMBED_URLS.VIMEO_EMBED}${videoId}`;
  }

  // Google Drive
  if (url.includes(VIDEO_EMBED_URLS.DRIVE_DOMAIN)) {
    return url.replace(
      VIDEO_EMBED_URLS.DRIVE_VIEW,
      VIDEO_EMBED_URLS.DRIVE_PREVIEW
    );
  }

  // Already embed-safe
  return url;
}



  openLessonVideo() {
  if (!this.lessonDetails?.embedded_video_url) return;

  this.videoLoading = true;

  this.sanitizedLessonVideoUrl =
    this.sanitizer.bypassSecurityTrustResourceUrl(
      this.convertToEmbedUrl(this.lessonDetails.embedded_video_url)
    );

  this.lessonVideoModal = true;
}

closeLessonVideo() {
  this.lessonVideoModal = false;
  this.sanitizedLessonVideoUrl = null;
  this.videoLoading = false;  
}

  onVideoLoaded() {
  this.videoLoading = false; 
}


  getTutorTip() {
    try {
      this.apiService
        .getLessonTutorTips(this.sessionData["lesson"])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          if (res) {
            this.tutorTip = res.tutor_tips;
            this.ufliStrategies = res.ufli_strategies || '';
          }
        });
    } catch (error) {
      console.error("Error fetching tutor tip:", error);
    }
  }

  uniqueFirstReadingWords() {
    return Array.from(new Set(this.firstReadingWords)) || [];
  }
  uniqueSecondReadingWords() {
    return Array.from(new Set(this.secondReadingWords)) || [];
  }
  handleUfliSTratergyModal(value: boolean) {
    this.ufliStrategyModal = value
    if (value) {
      this.ufliStrategyClickFlag = true
    }
  }
  tutorTipModalOpen(value: boolean) {
    this.tutorTipModal = value
  }

  setPassageDetails() {
    this.images = [];
    this.lessonDetails?.passage?.forEach((passage, index) => {
      if (index === this.passageIndex) {
        if (passage?.passage_images_array && passage.passage_images_array?.length) {
          passage.passage_images_array.forEach((passageImage: String) => {
            this.indexBasedImages.push({ path: passageImage });
          })
        }

        this.passageDetails = passage
      }

      this.images.push(...this.indexBasedImages)
      this.indexBasedImages = []
    })
  }

  getLessonDetails() {
    this.lessonsApiService
      .getLesson(this.sessionData["lesson"])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res) => {
          if (res) {
            this.lessonDetails = res;
            this.numberOfPassages = res?.passage?.length || 0;
            res?.passage?.forEach((passage, index) => {
              if (index === this.passageIndex) {
                if (passage?.passage_images_array && passage.passage_images_array?.length) {
                  passage.passage_images_array.forEach((passageImage: String) => {
                    this.indexBasedImages.push({ path: passageImage });
                  })
                }

                this.passageDetails = passage
              }

              this.images.push(...this.indexBasedImages)
              this.indexBasedImages = []
            })
            this.getSessionDetails()
          }
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  getSessionDetails() {
    this.loading = true
    try {
      const lessonStudentIds = {
        lessonId: this.sessionData["lesson"],
        studentId: this.sessionData["student"],
        passageId: this.passageDetails?.id
      };
      this.apiService
        .getSessionDetails(lessonStudentIds)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          if (!res?.data?.length) return;

          const sessionData = res.data;
          const passageIndex = sessionData.findIndex(item => item.current_step !== 2 && item.current_step != null);

          if (!this.passageToggled) {
            if (passageIndex !== -1) {
              this.passageIndex = this.lessonDetails.passage.findIndex(
                passage => passage.id === sessionData[passageIndex]?.passage_id
              );
              this.initialCurrentStepSet(sessionData[passageIndex].current_step + 1);
            } 
            else {
              const attendedPassageIds = new Set(sessionData.map(item => item.passage_id).filter(id => id != null));
              const notAttendedPassages = this.lessonDetails.passage.find(passage => !attendedPassageIds.has(passage.id));
              this.passageIndex = notAttendedPassages
                ? this.lessonDetails.passage.findIndex(p => p.id === notAttendedPassages.id)
                : 0;
              if (!notAttendedPassages || this.numberOfPassages === sessionData.length) {
                this.passageIndex = 0;
                this.currentStep = 0;
              }
            }
          }

          this.setPassageDetails();
          this.setReadingWords(sessionData);
          this.passageEngagement = sessionData;
          this.loading = false;
        });
    } catch (error) {
      this.loading = false;
      console.error("Error fetching tutor tip:", error);
    }
  }
  setCurrentPage() {
     if(this.currentStep ===3 && this.lessonDetails?.passage?.length === this.passageIndex+1){
      return enagagementTabs.postEngagement;
    } else{
      return enagagementTabs.passageEngagement;
    }
  }
  setReadingWords(passageProgressData) {
    const currentPassageProgress = passageProgressData?.find((passageProgression) => passageProgression?.passage_id === this.passageDetails?.id);
    this.firstReadingWords = currentPassageProgress?.first_read_words || [];
    this.secondReadingWords = currentPassageProgress?.second_read_words || [];
    this.firstReadingWordsIndex = currentPassageProgress?.first_read_words_index || [];
    this.secondReadingWordsIndex = currentPassageProgress?.second_read_words_index || [];
    this.whipWords = currentPassageProgress?.whip_words || [];
    this.phoneticsWords = currentPassageProgress?.phonetics_workspace || '';
  }
  async updateProgress(progress) {
    progress.current_page = this.setCurrentPage();
    progress.lesson = this.sessionData["lesson"];
    progress.volunteer = this.sessionData["volunteer"];
    progress.student = this.sessionData["student"];
    progress.curriculum_name = this.sessionData["curriculum_name"] || null;
    progress.current_step = this.currentStep - 1; // Adjusting for 0-based index;
    progress.first_read_words = this.firstReadingWords;
    progress.second_read_words = this.secondReadingWords;
    progress.whip_words = this.whipWords;
    progress.phonetics_workspace = this.phoneticsWords;
    progress.passage_id = this.passageDetails?.id;
    progress.word_count = this.passageDetails?.word_count
    progress.first_read_words_index = this.firstReadingWords?.length ? this.firstReadingWordsIndex : [];
    progress.second_read_words_index = this.secondReadingWords?.length ? this.secondReadingWordsIndex : [];
    return await this.updatePassageProgress(progress);
  }
  setIconByIndex(index) {
    document.body.style.cursor = `url(${this.icons[index]}) 16 16, auto`;
  }
  resetCursor() {
    this.cursorIcon = null;
    document.body.style.cursor = 'default';
  }
  resetCurserNone() {
    document.body.style.cursor = 'none'
  }
  toggleLaser() {
    this.showLaser = !this.showLaser;
    if (this.showLaser) {
      this.resetCurserNone();
    } else {
      this.setIconByIndex(this.firstHearing ? 0 : this.secondHearing ? 1 : -1);
    }
  }

  initialCurrentStepSet(currentStep: number) {
      if (!this.isSavingLoader) {
        this.currentStep = currentStep;
        this.passageToggled=true;
        switch (this.currentStep) {
          case 0:
            this.toggleFirstHearing();
            break;
          case 1:
            this.PingPongGame();
            break;
          case 2:
            this.toggleSecondHearing();
            break;
          case 3:
              this.handleNextPassage();
            break;
          default:
            break;
        }
      }
  }
  async toggleCurrentStep(currentStep: number) {
    if (!this.isSavingLoader) {
      this.currentStep = currentStep;
      this.passageToggled=true;
      let response: boolean = false;
      switch (this.currentStep) {
        case 0:
          this.images = [];
          this.getLessonDetails()
          this.toggleFirstHearing();
          break;
        case 1:
          response= await this.updateProgress(this.sessionData);
          if(response) {
          this.PingPongGame();
          }
          break;
        case 2:
          response= await this.updateProgress(this.sessionData);
          if(response) {
          this.toggleSecondHearing();
          }
          break;
        case 3:
          response=  await this.updateProgress(this.sessionData);
          if(response){
            this.handleNextPassage();
            this.setReadingWords(this.passageEngagement);
          }
          break;
        case -1:
          this.handlePrevPassage();
          break;
        default:
          break;
      }
    }
  }

  private handleNextPassage() {
    if (this.passageIndex + 1 <= this.lessonDetails?.passage?.length - 1) {
      this.passageIndex++;
      this.getSessionDetails();
      this.whipWords = [];
      this.setPassageDetails();
      this.currentStep = 0;
      this.toggleFirstHearing();
      this.ufliStrategyClickFlag = false
    } else {
      this.changeTab.emit(enagagementTabs.postEngagement);
      StorageService.setSessionCurrentPage(enagagementTabs.postEngagement);
    }
  }

  private handlePrevPassage() {
    if (this.passageIndex >= this.lessonDetails?.passage?.length - 1) {
      this.passageIndex--;
      this.getSessionDetails();
      this.setPassageDetails();
      this.currentStep = 0;
      this.toggleFirstHearing();
      this.ufliStrategyClickFlag = false
    } else {
      this.changeTab.emit(enagagementTabs.preEngagement);
      StorageService.setSessionCurrentPage(enagagementTabs.preEngagement);
    }
  }
  toggleSecondHearing() {
    this.secondHearing = true;
    this.firstHearing = false;
    this.showLaser = false;
    this.pingPongGame = false;
    this.setIconByIndex(1)
  }
  toggleFirstHearing() {
    this.firstHearing = true;
    this.secondHearing = false;
    this.showLaser = false;
    this.pingPongGame = false;
    this.setIconByIndex(0)
  }
  PingPongGame() {
    this.pingPongGame = true;
    this.showLaser = true;
    this.firstHearing = false;
    this.secondHearing = false;
    this.resetCurserNone()
  }

  async updatePassageProgress(progress) {
    try {
      this.isSavingLoader = true;
      const res = await this.apiService.updatePassageEngagement(progress).toPromise();
      if (res) {
        // this.goToTab(res.data?.current_page);
        return true
      }
    } catch (err) {
      this.toastrService.error(errorMessages.UPDATE_PROGRESS_FAILED);
      return false
      // handle error if needed
    } finally {
      this.isSavingLoader = false;
    }
  }
  ngOnDestroy() {
    document.body.style.cursor = null;
    this.subscription?.unsubscribe();
  }
}
